import { AnyAction } from '@reduxjs/toolkit';
import { REMOVE_SELECTED_USER, SELECT_USER, REMOVE_ALL_SELECTED_USERS } from '../action-types';
import type { IRemoveSelectedExternalUserAction, ISelectExternalUserAction } from '../actions';
import type { ICustomerUsersExternalSelectionState } from '../interfaces';

export const initialState: ICustomerUsersExternalSelectionState = {
  data: [],
};

export const customerUsersExternalSelectionReducer = (
  state: ICustomerUsersExternalSelectionState = initialState,
  action: AnyAction,
): ICustomerUsersExternalSelectionState => {
  switch (action.type) {
    case SELECT_USER:
      return {
        ...state,
        data: [...state.data, (action as ISelectExternalUserAction).user],
        isFetching: false,
      };
    case REMOVE_SELECTED_USER:
      return {
        ...state,
        data: state.data.filter((i) => i.userId !== (action as IRemoveSelectedExternalUserAction).user.userId),
      };

    case REMOVE_ALL_SELECTED_USERS:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
